import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Paper, Typography } from "@mui/material";
import { deleteTask } from "../../../services/aws/ecs";
import { ALERT_MESSAGES } from "../constants/taskConstants";

/**
 * Confirm delete dialog for task deletion confirmation.
 */
function ConfirmDeleteDialog({ deleteDialog, setDeleteDialog, showAlert, cluster, refreshTasks }) {
  const dismissDialog = () => {
    setDeleteDialog({
      isOpen: false,
      taskData: null,
    });
  };

  const handleTaskDeletion = async () => {
    const res = await deleteTask(deleteDialog.taskData.id, cluster);
    if (res.status === 200) {
      showAlert("success", ALERT_MESSAGES.DELETE_SUCCESS);
      refreshTasks();
      dismissDialog();
    } else {
      showAlert("error", ALERT_MESSAGES.DELETE_ERROR);
    }
  };

  return (
    <Dialog open={deleteDialog.isOpen} onClose={dismissDialog}>
      <DialogTitle>Confirm Delete Task</DialogTitle>
      <DialogContent>
        <Divider sx={{ mb: 2 }} />
        <Typography variant="body1">Are you sure you want to delete this task?</Typography>
        {deleteDialog.taskData && (
          <>
            <Typography variant="body2" sx={{ mt: 2 }}>
              Task Details:
            </Typography>
            <Paper>
              <pre
                style={{
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-all",
                  padding: "8px",
                  borderRadius: "4px",
                }}
              >
                {JSON.stringify(deleteDialog.taskData.row, null, 2)}
              </pre>
            </Paper>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={dismissDialog}>Cancel</Button>
        <Button color="error" onClick={handleTaskDeletion}>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmDeleteDialog;
